import { Subject } from 'rxjs';

const updateMins = new Subject();
const submitTest = new Subject();

export {
    updateMins,
    submitTest
}